// @flow
import * as React from 'react'
import { styled } from 'mz-ui-kit'
import FlagIcon from 'mz-icons/flag'

// Types
export type Props = {
  country: string,
  children?: React.Node,
}

// Elements
const Label = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
})
const ChildrenWrapper = styled('div', {
  marginLeft: '8px',
})

/**
 * Label component that shows a flag and country name on the right side of it
 * @param  {props}
 * @return {React.Element}
 */
const FlagLabel = ({ country, children }: Props) => (
  <Label>
    <FlagIcon country={country} />
    {children && <ChildrenWrapper>{children}</ChildrenWrapper>}
  </Label>
)

export default FlagLabel
